export const PERMISSION = {
  ADMIN: ["Admin"],
  VIEW: ["Admin", "Web"],
};

export const TEST_PROTOCOL = "http://";
export const TEST_HOST_WITH_COLUMNS = "portale-si.prod.eggscloud.it";
export const TEST_PORT = "80";

export const APP_PROTOCOL =
  window.location.port === "4242"
    ? TEST_PROTOCOL
    : window.location.protocol + "//";
export let APP_HOST =
  window.location.port === "4242"
    ? TEST_HOST_WITH_COLUMNS + ":"
    : window.location.hostname + ":";
export const APP_PORT =
  window.location.port === "4242" ? TEST_PORT : window.location.port;

export const APP_CONTEXT = "";
export const APP_API = "/api/";
export const APP_NAME =
  APP_PROTOCOL + APP_HOST + APP_PORT + APP_CONTEXT + APP_API;
export const DOCS_PATH = APP_NAME + "/documents/";
export const DOCS_REPLACE = (uuid: string) =>
  APP_NAME + "documents/" + `${uuid}` + "/download";
export const DOCS_REPLACE_NAME = (uuid: string, name: string) =>
  APP_NAME + "documents/" + `${uuid}` + "/download/" + `${name}`;
export const ALLEGATI_API_PATH = APP_NAME + "documents";
export const SETTORI_API_PATH = APP_NAME + "settori";
export const BANNERS_API_PATH = APP_NAME + "banners";
export const SERVIZI_API_PATH = APP_NAME + "servizio";
export const GALLERIA_API_PATH = APP_NAME + "gallerie";
export const DOCUMENTI_API_PATH = APP_NAME + "documenti";
export const NEWS_API_PATH = APP_NAME + "news";
export const CAREERS_API_PATH = APP_NAME + "careers";
export const FORMREQUEST_API_PATH = APP_NAME + "formrequest";
export const FORMREQUESTCAREERS_API_PATH = APP_NAME + "formrequestcareers";
export const BLOG_API_PATH = APP_NAME + "blog";
export const UTENTI_LOGIN_API_PATH = "utenti-login";
export const TIPOLOGIE_NEWS_API_PATH = APP_NAME + "tipologia-news";
export const TIPOLOGIE_BANNERS_API_PATH = APP_NAME + "tipologie-banners";
export const BANNERS_SEZIONI_API_PATH = APP_NAME + "banner-sezione";
export const ATTIVITA_API_PATH = APP_NAME + "attivita";
export const SOTTOSERVIZI_API_PATH = APP_NAME + "sotto-servizio";
export const CONTENUTI_GENERICI_API_PATH = APP_NAME + "contenuto-generico";
export const MULTILINGUE_API_PATH = APP_NAME + "multilingue";
export const SOTTOATTIVITA_API_PATH = APP_NAME + "sotto-attivita";
export const STORIE_API_PATH = APP_NAME + "storie";
export const SEDI_API_PATH = APP_NAME + "sedi";
export const VIDEO_API_PATH = APP_NAME + "video";
export const DOCUMENTS_MIMETYPE_API_PATH = APP_NAME + "documents_mimetype";

export const TABLE_NAME = "table_name";
export const TABLE_KEY = "table_key";

export const STUDI_ITEMS = [
  { label: "Licenza elementare", value: "Licenza elementare" },
  { label: "Licenza media", value: "Licenza media" },
  {
    label: "Titolo di istruzione secondaria superiore",
    value: "Titolo di istruzione secondaria superiore",
  },
  {
    label: "Diploma di istruzione secondaria superiore",
    value: "Diploma di istruzione secondaria superiore",
  },
  {
    label: "Diploma terziario extra-universitario",
    value: "Diploma terziario extra-universitario",
  },
  { label: "Laurea di primo livello", value: "Laurea di primo livello" },
  { label: "Diploma di laurea", value: "Diploma di laurea" },
  {
    label: "Laurea specialistica a ciclo unico",
    value: "Laurea specialistica a ciclo unico",
  },
  { label: "Laurea specialistica", value: "Laurea specialistica" },
  {
    label: "Master universitario di primo livello",
    value: "Master universitario di primo livello",
  },
  {
    label: "Master universitario di secondo livello",
    value: "Master universitario di secondo livello",
  },
  {
    label: "Diploma di specializzazione",
    value: "Diploma di specializzazione",
  },
  {
    label: "Titolo di dottore di ricerca",
    value: "Titolo di dottore di ricerca",
  },
];

export const PROTETTO_ITEMS = [
  { label: "Si", value: "Si" },
  { label: "No", value: "No" },
];

export const PROFESSIONALE_ITEMS = [
  { label: "Full-time", value: "Full-time" },
  { label: "Part-time", value: "Part-time" },
  { label: "Orario prestabilito", value: "Orario prestabilito" },
];

export const PAESI_IT = [
  "Italia",
  "Europa",
  "Asia",
  "Sud America",
  "Nord America",
  "Africa",
];

export const PAESI_EN = [
  "Italy",
  "Europe",
  "Asia",
  "South America",
  "North America",
  "Africa",
];

export const TELE_BORSA_API =
  "https://syndication.teleborsa.it/serviziitalia/2019/json/json-teleborsa";

export const GRUPPO = "gruppo";
export const STORIA = "storia";
export const SERVIZI = "servizi";
export const SETTORI = "settori";
export const SOSTENIBILITA = "sostenibilita";
export const MEDIA = "media";
export const BLOG = "blog";
export const INVESTOR_RELATIONS = "investor-relations";
export const HOMEPAGE = "homepage";
export const CORPORATE_GOVERNANCE = "corporate-governance";
export const CONTATTI = "contatti";

export const TOKEN_KEY = "ictportal.asset_authData";
export const APP_VERSION = "1.0";

export const MENU_PRIMARY_ITA = [
  { url: "/homepage", titolo: "Home" },
  { url: "/societa-trasparente", titolo: "Societa trasparente" },
  { url: "/investor-relations", titolo: "Investors" },
  { url: "/corporate-governance", titolo: "Governance" },
  { url: "/contatti", titolo: "Contatti" },

];

export const MENU_PRIMARY_ENG = [
  { url: "/homepage-en", titolo: "Home" },
  { url: "/transparent-company", titolo: "Transparent Company" },
  { url: "/investor-relations-en", titolo: "Investors" },
  { url: "/corporate-governance-en", titolo: "Governance" },
  { url: "/contacts", titolo: "Contacts" },
];

export const MENU_SECONDARY_ITA = [
  { url: "/", titolo: "Home", class: "" },
  { url: "/gruppo", titolo: "Il Gruppo", class: "" },
  { url: "/servizi", titolo: "Servizi", class: "" },
  { url: "/aree-di-attivita", titolo: "Aree di Attività", class: "" },
  { url: "/sostenibilita", titolo: "Sostenibilità", class: "" },
  { url: "/media", titolo: "Media", class: "" },
  { url: "/blog", titolo: "Blog", class: "" },
  { url: "/contatti", titolo: "Contatti" },
];

export const MENU_BOTTOM_PRIMARY_ITA = [
  { url: "/servizi-italia-nel-mondo", titolo: "Servizi Italia nel mondo" },
  { url: "/societa-trasparente", titolo: "Societa trasparente" },
  { url: "/investor-relations", titolo: "Investor Relations" },
  { url: "/corporate-governance", titolo: "Corporate Governance" },
  { url: "/faq", titolo: "FAQ" },
];

export const MENU_BOTTOM_SECONDARY_ITA = [
  { url: "/", titolo: "Home" },
  { url: "/gruppo", titolo: "Il Gruppo" },
  { url: "/servizi", titolo: "Servizi" },
  { url: "/aree-di-attivita", titolo: "Aree di Attività" },
  { url: "/sostenibilita", titolo: "Sostenibilità" },
  { url: "/media", titolo: "Media" },
  { url: "/contatti", titolo: "Contatti" },
];



export const MENU_SECONDARY_ENG = [
  { url: "/homepage-en", titolo: "Home" },
  { url: "/group", titolo: "The Group" },
  { url: "/services", titolo: "Services" },
  { url: "/areas-of-activity", titolo: "Activities" },
  { url: "/sustainability", titolo: "Sustainability" },
  { url: "/media-en", titolo: "Media" },
  { url: "/contacts", titolo: "Contacts" },
];

export const MENU_PRIMARY_PT = [
  {
    url: "/societa-trasparente",
    titolo: "Sociedade Transparente",
  },
  { url: "/investor-relations-en", titolo: "Investor Relations" },
  { url: "/corporate-governance-en", titolo: "Corporate Governance" },
];

export const MENU_SECONDARY_PT = [
  { url: "/pagina-inicial", titolo: "Pagina Inicial" },
  { url: "/grupo", titolo: "Grupo" },
  { url: "/servios", titolo: "Servicos" },
  { url: "/reas-de-atuao", titolo: "Areas de Atuacao" },
  { url: "/sustentabilidade", titolo: "Sustentabilidade" },
  { url: "/media", titolo: "Media" },
  { url: "/contatos", titolo: "Contatos"},
];

export const MENU_BOTTOM_PRIMARY_ENG = [
  {
    url: "/servizi-italia-in-the-world",
    titolo: "Servizi Italia in the world",
  },
  { url: "/transparent-company", titolo: "Transparent Company" },

  { url: "/investor-relations-en", titolo: "Investor Relations" },
  { url: "/corporate-governance-en", titolo: "Corporate Governance" },
  { url: "/faq-en", titolo: "FAQ" },
];

export const MENU_BOTTOM_SECONDARY_ENG = [
  { url: "/homepage-en", titolo: "Home" },
  { url: "/group", titolo: "The Group" },
  { url: "/services", titolo: "Services" },
  { url: "/areas-of-activity", titolo: "Activities" },
  { url: "/sustainability", titolo: "Sustainability" },
  { url: "/media-en", titolo: "Media" },
  { url: "/contacts", titolo: "Contacts" },
];

export const MENU_BOTTOM_SECONDARY_PT = [
  { url: "/pagina-inicial", titolo: "Pagina Inicial" },
  { url: "/grupo", titolo: "Grupo" },
  { url: "/servios", titolo: "Servicos" },
  { url: "/reas-de-atuao", titolo: "Areas de Atuacao" },
  { url: "/sustentabilidade", titolo: "Sustentabilidade" },
  { url: "/media", titolo: "Media" },
  { url: "/contatos", titolo: "Contatos", class: "active-button" },
];

export const MENU_BOTTOM_PRIMARY_PT = [
  {
    url: "/servizi-italia-in-the-world",
    titolo: "Servizi Italia in the world",
  },
  {
    url: "/societa-trasparente",
    titolo: "Sociedade Transparente",
  },
  { url: "/investor-relations-en", titolo: "Investor Relations" },
  { url: "/corporate-governance-en", titolo: "Corporate Governance" },
  { url: "/faq-en", titolo: "FAQ" },
];
